import axios from 'axios';
import router from '../router';
import VueCookies from 'vue-cookies';

let baseURL = process.env.API_ROOT;
if (process.env.NODE_ENV == 'development') {
  baseURL = '/api'
} else {
  baseURL = window.Glod.reqUrl;
}
axios.defaults.timeout = 30000;
axios.defaults.baseURL = baseURL;
console.log(axios.defaults.baseURL);

var errorInfoTO = 0;
var errorInfoArray = new Set(); // 错误信息，过滤重复
//var userId = $cookies.get("clientUserId");


export function postjson(url, params, headers) {
  return new Promise((resolve, reject) => {
    let headerconfig = {
      url: url,
      data: params,
      method: 'POST',
    };
    let AccessToken = localStorage.getItem('token');
    if (headers == undefined || headers == {}) {
      //请求头添加token
      headerconfig.headers = {
        'Content-Type': 'application/json',
        Authorization: AccessToken
      };
    } else {
      headerconfig.headers = {};
      try {
        headerconfig.headers = JSON.parse(JSON.stringify(headers));
      } catch (e) {}
      headerconfig.headers.Authorization = AccessToken;
    }
    axios
      .request(headerconfig)
      .then(res => {
        //console.log(res);
        if(res.data.error == undefined) {
          resolve(res.data)
          return
        }
        if (res.data.error == 401) {
          showErrorInfo('登录过期');
          // 跳登录页面
          router.push({
            path: '/'
          });
        } else if (res.data.error == 0) {
          resolve(res.data);
        } else {
          showErrorInfo(res.data.errmsg);
          resolve(res.data);
        }
      })
      .catch(err => {
        resolve({});
        showErrorInfo('服务出错:' + err);
      });
  });
}

export function deletejson(url, params, headers) {

  return new Promise((resolve, reject) => {
    let headerconfig = {
      url: url,
      data: params,
      method: 'DELETE',
    };
    let AccessToken = localStorage.getItem('token');
    if (headers == undefined || headers == {}) {
      //请求头添加token
      headerconfig.headers = {
        'Content-Type': 'application/json',
        Authorization: AccessToken
      };
    } else {
      headerconfig.headers = {};
      try {
        headerconfig.headers = JSON.parse(JSON.stringify(headers));
      } catch (e) {}
      headerconfig.headers.Authorization = AccessToken;
    }
    axios
      .request(headerconfig)
      .then(res => {
        //console.log(res);        
        if (res.data.error == 401) {
          showErrorInfo('登录过期');
          // 跳登录页面
          router.push({
            path: '/'
          });
        } else if (res.data.error == 0) {
          resolve(res.data);
        } else {
          showErrorInfo(res.data.message);
          resolve(res.data);
        }
      })
      .catch(err => {
        resolve({});
        showErrorInfo('服务出错:' + err);
      });
  });
}

export function putjson(url, params, headers) {
  return new Promise((resolve, reject) => {
    let headerconfig = {
      url: url,
      data: params,
      method: 'PUT',
    };
    let AccessToken = localStorage.getItem('token');
    if (headers == undefined || headers == {}) {
      //请求头添加token
      headerconfig.headers = {
        'Content-Type': 'application/json',
        Authorization: AccessToken
      };
    } else {
      headerconfig.headers = {};
      try {
        headerconfig.headers = JSON.parse(JSON.stringify(headers));
      } catch (e) {}
      headerconfig.headers.Authorization = AccessToken;
    }
    axios
      .request(headerconfig)
      .then(res => {
        //console.log(res);
        if (res.data.error == 401) {
          showErrorInfo('登录过期');
          // 跳登录页面
          router.push({
            path: '/'
          });
        } else if (res.data.error == 0) {
          resolve(res.data);
        } else {
          showErrorInfo(res.data.message);
          resolve(res.data);
        }
      })
      .catch(err => {
        resolve({});
        showErrorInfo('服务出错:' + err);
      });
  });
}

export function getjson(url, params, headers) {
  //console.log(params)
  return new Promise((resolve, reject) => {
    let headerconfig = {
      url: url,
      params: params,
      method: 'GET',
    };
    let AccessToken = localStorage.getItem('token');
    if (headers == undefined || headers == {}) {
      //请求头添加token
      headerconfig.headers = {
        'Content-Type': 'application/json',
        Authorization: AccessToken
      };
    } else {
      headerconfig.headers = {};
      try {
        headerconfig.headers = JSON.parse(JSON.stringify(headers));
      } catch (e) {}
      headerconfig.headers.Authorization = AccessToken;
    }
    axios
      .request(headerconfig)
      .then(res => {
        if (res.data.error == 401) {
          showErrorInfo('登录过期');
          // 跳登录页面
          router.push({
            path: '/'
          });
        } else if (res.data.error == 0) {
          resolve(res.data);
        } else {
          showErrorInfo(res.data.message);
          resolve(res.data);
        }
      })
      .catch(err => {
        resolve({});
        showErrorInfo('服务出错:' + err);
      });
  });
}



export function download(url, params, headers) {
  //console.log(params)
  return new Promise((resolve, reject) => {
    let headerconfig = {
      url: url,
      params: params,
      method: 'GET',
      responseType: 'blob',
    };
    let AccessToken = localStorage.getItem('token');
    if (headers == undefined || headers == {}) {
      //请求头添加token
      headerconfig.headers = {
        'Content-Type': 'application/vnd.ms-excel',
        Authorization: AccessToken
      };
    } else {
      headerconfig.headers = {
        'Content-Type': 'application/vnd.ms-excel'
      };
      try {
        headerconfig.headers = JSON.parse(JSON.stringify(headers));
      } catch (e) {}
      headerconfig.headers.Authorization = AccessToken;
    }
    axios
      .request(headerconfig)
      .then(res => {
        console.log(res.data)
        resolve(res);
      })
      .catch(err => {
        resolve({});
        showErrorInfo('服务出错:' + err);
      });
  });
}


function clearCookies() {}

function showErrorInfo(errMsg) {
  errorInfoArray.add(errMsg);

  if (errorInfoTO) {
    clearTimeout(errorInfoTO);
  }
  errorInfoTO = setTimeout(function() {
    errorInfoArray.forEach(t => {
      alert(t);
    });
    errorInfoArray.clear();
  }, 500);
}



// WEBPACK FOOTER //
// ./src/api/http.js